// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFoundPage_container__1Xbnh","title":"NotFoundPage_title__2jGMB","text":"NotFoundPage_text__mXhKe"};